/**
  Color Swatch JavaScript
  Handles the color swatch functionality for product cards
**/ 

document.addEventListener('DOMContentLoaded', function() {
  const colorSwatches = document.querySelectorAll('.product-color-swatches');
  
  colorSwatches.forEach(swatchContainer => {
    const swatches = swatchContainer.querySelectorAll('.color-swatch');
    const productId = swatchContainer.dataset.productId;
    const productImage = document.querySelector(`.card-wrapper[data-product-id="${productId}"] .card__media img`);
    
    if (!productImage) return;
    
    swatches.forEach(swatch => {
      swatch.addEventListener('click', function() {
        // Remove active class from all swatches
        swatches.forEach(s => s.classList.remove('active'));
        // Add active class to clicked swatch
        this.classList.add('active');
        
        // Update product image
        const newSrc = this.dataset.imageSrc;
        const newSrcset = this.dataset.imageSrcset;
        
        productImage.src = newSrc;
        productImage.srcset = newSrcset;
      });
    });
  });
});